import React from 'react';
import pluralize from 'pluralize';

import { type ILead, type ILeadLabel, useUpdateLeads, useLeadLabels } from 'src/services/api';
import { LeadUtils } from 'src/utils';
import BulkEditLabelsModal from 'src/components/bulk-edit-labels-modal/BulkEditLabelsModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    leads: ILead[];
};

export default function BulkChangeLeadLabelModal({
    open,
    onClose,
    onSuccess,
    leads,
}: Props) {
    const {
        mutateAsync: updateLeads,
        isLoading: isUpdatingLeads,
    } = useUpdateLeads();

    const { data: allLeadLabels = [] } = useLeadLabels();

    return (
        <BulkEditLabelsModal
            open={open}
            onClose={onClose}
            title="Edit Lead Labels"
            items={leads.map((lead) => ({
                id: lead.uuid,
                name: LeadUtils.getLeadName(lead),
                labels: lead.labels,
            }))}
            allLabels={allLeadLabels}
            warningText={`This action will overwrite the existing labels for ${leads.length} ${pluralize('lead', leads.length)}.`}
            isSaving={isUpdatingLeads}
            onSave={async (updatedItems) => {
                await updateLeads(updatedItems.map((item) => ({
                    uuid: item.id as string,
                    labels: item.labels as ILeadLabel[],
                })));
                onSuccess();
                onClose();
            }}
        />
    );
}
